import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20",
  class: "globe_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 19.167A9.167 9.167 0 1 0 10 .833a9.167 9.167 0 0 0 0 18.334ZM10 2.5c-1.172 0-2.136 2.96-2.25 6.75h4.5C12.138 5.46 11.174 2.5 10 2.5Zm3.043 1.766c-.14-.467-.31-.921-.513-1.333 2.692.954 4.678 3.388 4.97 6.317H13.76c-.054-1.888-.307-3.63-.716-4.984ZM2.501 9.25h3.742c.053-1.888.306-3.63.715-4.984a8.7 8.7 0 0 1 .513-1.333c-2.692.954-4.678 3.388-4.97 6.317Zm0 1.5c.292 2.93 2.278 5.363 4.97 6.317a8.699 8.699 0 0 1-.513-1.333c-.409-1.354-.662-3.096-.715-4.984H2.5Zm5.25 0c.113 3.79 1.077 6.75 2.25 6.75 1.172 0 2.136-2.96 2.25-6.75h-4.5Zm9.75 0h-3.742c-.054 1.888-.307 3.63-.716 4.984-.14.467-.31.921-.513 1.333 2.692-.954 4.678-3.387 4.97-6.317Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }